module.exports = __webpack_public_path__ + "img/maarten-spruyt2.ed33d31d.jpg";